import React, { FunctionComponent } from 'react';

import { I18nElementProps, I18N as TankerI18N } from 'react-tanker';

import { getAppLang } from '../../../../utils/common-i18n';

export type I18NProps = Omit<I18nElementProps, 'lang'>;

const I18N: FunctionComponent<I18NProps> = ({ children, ...props }) => {
    const lang = getAppLang();

    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <TankerI18N lang={lang} {...props}>
            {children}
        </TankerI18N>
    );
};

export default I18N;
